// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable react/sort-comp, react/static-property-placement, no-negated-condition, react/no-did-mount-set-state */

import React, { PureComponent } from "react"

import Spinner from "../components/Spinner/Spinner"

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line react/jsx-filename-extension
const ErrorFallback = () => <div>There was an error, please reload the page.</div>

const DEFAULT_ATTEMPTS = 5
const ATTEMPT_DELAY_MS = 1500

export function asyncLoad(Component, attemptsLeft = DEFAULT_ATTEMPTS) {
  return (
    Component.maybeAsyncLoad()
      .then((m) => m.default)
      .then((AsyncComponent) => {
        Component.displayName = `Async(${Component.displayName})`
        Component.AsyncComponent = AsyncComponent
      })
      // Inspiration: https://gist.github.com/Botfather/4cfc9c7ba363c892acced7cc44d9f7ff#file-componentloader-js
      .catch(() => {
        setTimeout(() => {
          if (attemptsLeft === 1) {
            Component.displayName = "AsyncErrorFallback"
            Component.AsyncComponent = ErrorFallback
            return
          }
          asyncLoad(Component, attemptsLeft - 1)
        }, ATTEMPT_DELAY_MS)
      })
  )
}

export default function makeAsync(getComponent, { Loader = Spinner, lazy } = {}) {
  return class Async extends PureComponent {
    // FIXME: sort methods in React components according to conventions

    static AsyncComponent = null

    static maybeAsyncLoad = lazy ? null : getComponent

    state = { Component: Loader, attemptsLeft: DEFAULT_ATTEMPTS }

    loadComponent() {
      getComponent()
        .then((m) => m.default)
        .then((AsyncComponent) => {
          Async.displayName = `Async(${AsyncComponent.displayName})`
          Async.AsyncComponent = AsyncComponent
          this.setState({ Component: AsyncComponent })
        })
        .catch(() => {
          // Inspiration: https://gist.github.com/Botfather/4cfc9c7ba363c892acced7cc44d9f7ff#file-componentloader-js
          setTimeout(() => {
            const { attemptsLeft } = this.state
            if (attemptsLeft === 1) {
              Async.displayName = "AsyncErrorFallback"
              Async.AsyncComponent = ErrorFallback
              this.setState({ Component: ErrorFallback })
              return
            }
            this.setState(
              (state) => ({ ...state, attemptsLeft: state.attemptsLeft - 1 }),
              () => this.loadComponent(),
            )
          }, ATTEMPT_DELAY_MS)
        })
    }

    componentDidMount() {
      if (!Async.AsyncComponent) {
        this.loadComponent()
      } else {
        this.setState({ Component: Async.AsyncComponent })
      }
    }

    render() {
      const { Component } = this.state

      return <Component {...this.props} />
    }
  }
}
